import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetAppIcon from "@mui/icons-material/GetApp";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { useBox } from "../../../Finanzas/Helper/useBox";
import { GetKey } from "../../../Finanzas/Actions/GetContainer";
import { FiltroReporteVisitas } from "./FiltroReporteVisitas";
import { ReporteVisitasGrafica } from "./ReporteVisitasGrafica";
import { ReporteVisitasTabla } from "./ReporteVisitasTabla";

const hoy = new Date();
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split("T")[0];
const fechaHoy = hoy.toISOString().split("T")[0];

// Reporte de Visitas Programadas — gráfica (info_grafica: programadas/realizadas por asesor) +
// tabla agrupada por asesor (listado_visitas, plano). Conectado a
// ReportesCRM/ReporteVisitasProgramadas?fechainicio&fechafin&adr&sucursal.
export const CRM_ReporteVisitasProgramadas = () => {
  const history = useHistory();

  const [boxstate, setBoxState] = useBox({
    fechaInicio: primerDiaMes,
    fechaFin: fechaHoy,
    pv: { adr: [], sucursal: [] },
  });

  const [infoGrafica, setInfoGrafica] = useState([]);
  const [listadoVisitas, setListadoVisitas] = useState([]);
  const [permisos, setPermisos] = useState();
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
  // Qué asesor está desplegado en la tabla — vive aquí para que el click en una barra de
  // la gráfica y el click en la fila de la tabla controlen el mismo estado
  const [abiertos, setAbiertos] = useState({});

  const handleToggleAsesor = (idvendedor) => {
    setAbiertos((prev) => ({ ...prev, [idvendedor]: !prev[idvendedor] }));
  };

  // Click en la barra del asesor: lo despliega (si estaba cerrado) y hace scroll hasta su
  // fila en la tabla, igual que si se hubiera dado click directamente ahí
  const handleAsesorClick = (idvendedor) => {
    setAbiertos((prev) => ({ ...prev, [idvendedor]: true }));
    requestAnimationFrame(() => {
      document.getElementById(`rv-asesor-${idvendedor}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  };

  const cargarReporte = ({ fechaInicio, fechaFin }) => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ReporteVisitasProgramadas?fechainicio=${fechaInicio}&fechafin=${fechaFin}&adr=${adr}&sucursal=${sucursal}`)
      .then((result) => {
        setInfoGrafica(Array.isArray(result?.info_grafica) ? result.info_grafica : []);
        setListadoVisitas(Array.isArray(result?.listado_visitas) ? result.listado_visitas : []);
        setPermisos(result?.permisos);
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("REPORTE DE VISITAS", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    cargarReporte({ fechaInicio: boxstate.fechaInicio, fechaFin: boxstate.fechaFin });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Descarga el Excel del reporte — ReportesCRM/ImprimirExcelReporteVisitasProgramadas.
  const onGeneraExcel = () => {
    let adr = GetKey(boxstate.pv.adr, ["idadr"]);
    let sucursal = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    if (!adr) adr = "0";
    if (!sucursal) sucursal = "0";

    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ReportesCRM/ImprimirExcelReporteVisitasProgramadas?fechainicio=${boxstate.fechaInicio}&fechafin=${boxstate.fechaFin}&adr=${adr}&sucursal=${sucursal}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${filename}.xlsx`;
        downloadLink.click();
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("REPORTE DE VISITAS", JSON.stringify(error), "error");
      });
  };

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rv-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={() => history.goBack()}>
                    <ArrowBackIcon /> Regresar
                  </button>
                  <FiltroReporteVisitas onCargar={cargarReporte} boxState={boxstate} onBoxChange={setBoxState} permisos={permisos} />
                </div>
                <div className="crm-head-center">
                  <p className="crm-module-subtitle">Reportes</p>
                  <h1 className="crm-module-title">REPORTE DE VISITAS</h1>
                </div>
                <div className="crm-head-right">
                  <button className="crmcs-btn-excel" onClick={onGeneraExcel}>
                    <GetAppIcon /> Excel
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper rv-wrapper scroll">
              <ReporteVisitasGrafica datos={infoGrafica} onAsesorClick={handleAsesorClick} />
              <ReporteVisitasTabla listado={listadoVisitas} abiertos={abiertos} onToggle={handleToggleAsesor} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
